import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { AccountService } from '../../shared/services/account.service';
import { AppService } from "../../shared/services/app.service";
import { Router, ActivatedRoute } from '@angular/router';
import { LanguageService } from '../../shared/services/language.service';
import { DOCUMENT } from '@angular/common';
import {DomSanitizer,SafeResourceUrl,} from '@angular/platform-browser';
import { ProductsService } from '../../shared/services/products.service';
import { BasketService } from '../../shared/services/basket.service';

declare var $: any; import {isBrowser} from '../../shared/thirdparty/isBrowser'
import { TranslateService } from '@ngx-translate/core';
declare var Swal:any;

@Component({
  selector: 'app-journee-securite',
  templateUrl: './journee-securite.component.html',
  styleUrls: ['./journee-securite.component.scss']
})
export class JourneeSecuriteComponent implements OnInit {

    public prices:any = {

    }
    public loading = true

  constructor(
      public accountService : AccountService,
      private productService: ProductsService,
      public appService : AppService,
      public router : Router,
      public language : LanguageService,
      public translate: TranslateService,
      public sanitizer:DomSanitizer,
      public basketService : BasketService,
      @Inject(DOCUMENT) public document: Document
  ) { }

  videosByLang = {
    fr: 'https://www.youtube.com/embed/SjbPbzSwIFE',
    en: 'https://www.youtube.com/embed/3oG2Uf45_8w'
  }

  public videoSrc : SafeResourceUrl;


public listProducts:any = [];
public ids = [144,84,85,46,99,143];
public currentLang


  ngOnInit() {
      this.getCurrentLang()
      this.refreshPrices()

      if(isBrowser() && $('video') && $('video').length){
          for (let i = 0; i<$('video').length; i++) {
              $('video')[i].muted = true;
              $('video')[i].load();
          }
      }
      this.videoSrc = this.sanitizer.bypassSecurityTrustResourceUrl("");

      this.productService.searchProducts(null, [224], 0, 1000)
      .then((resultats)=>{
        this.listProducts = this.productService.setProductsInfos(resultats["datas"],-1,-1);
      })

      return this.basketService.getPrices()
      .then((prices)=>{
          this.prices = prices
          // console.log(prices)
      })


  }


  video(){
    const url = this.videosByLang[this.language.translate.currentLang];
    this.videoSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url+"?autoplay=1&amp;modestbranding=1&amp;showinfo=0");

    var modal = document.querySelector(".modal");
    var container = modal.querySelector(".modal-content");

    // Check if we click outside the modal in order to stop the video
    document.querySelector(".modal").addEventListener("click", function (e) {
      if (e.target !== container){
        document.getElementById("video").setAttribute('src', '');
      }
    });

  }


  refreshPrices(){
      this.loading = true
      return this.basketService.getPrices()
      .then((prices)=>{
          this.loading = false
          this.prices = prices
      })
  }

  getCurrentLang(){
      this.currentLang = this.translate.store.currentLang;
  }


  freeAccess(){
      this.router.navigate(this.language.navigateAccordingToLang(['/demo']))
  }

}
